module.exports = __webpack_public_path__ + "images/financial-world-e1c7c1.png";